module.exports = __webpack_public_path__ + "img/Environmental_Design_-_RN-t-22338-003.5b45401e.jpg";